import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';

const ModalDelete = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <section className="module-title modal-title">
      <h2>{props.language.account.workingShiftGroup.deactivateWorkingShiftGroup}</h2>
      {props.statusSave == 500 && (
        <p className="error">{props.language.error[`cod${props.dataSave.error.code}`]}</p>
      )}
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
    </section>
    {props.statusSave != 200 && (
      <div className={`box-modal max500`}>
        <section className="base-form">
          <div className="module-title">
            <input type="hidden" defaultValue={props.config.id} id="iddelete" />
            <p className="bold">
              {props.language.account.workingShiftGroup.deactivateWorkingShiftGroupLabel}{' '}
              {props.config.alias} {props.language.account.workingShiftGroup.deactivateWorkingShiftGroupLabelOne}
            </p>
            <p>{props.language.account.workingShiftGroup.deactivateWorkingShiftGroupLabelTwo}</p>
          </div>
        </section>
      </div>
    )}
    {props.statusSave != 200 && (
      <div className="box-form islabel top center modal-button-box">
        <div>
          <input
            className="activered width150 marginside"
            onClick={props.handleSubmit}
            type="button"
            value={props.language.account.workingShiftGroup.deleteText}
          />
          <input
            className="width150 marginside"
            data-close="ok"
            onClick={props.handleModal}
            type="button"
            value={props.language.account.workingShiftGroup.cancel}
          />
        </div>
      </div>
    )}
    {props.statusSave == 200 && (
      <div className={`box-modal max500`}>
        <section className={'feed-back green'}>
          <div>
            <i className="fas fa-check-circle" />
          </div>
          <div>
            <p>
              {props.language.account.workingShiftGroup.workingShiftGroupTextOne} {props.config.alias}{' '}
              {props.language.account.workingShiftGroup.workingShiftGroupTextTwo}
            </p>
          </div>
        </section>
      </div>
    )}
  </div>
);

export default ModalDelete;



// WEBPACK FOOTER //
// ./source/client/components/account_working_shift_group/modalDelete.jsx